module.exports = __webpack_public_path__ + "img/next.da2abc5a.png";